import { render, staticRenderFns } from "./BannerLocation.vue?vue&type=template&id=12198b01&scoped=true"
import script from "./BannerLocation.vue?vue&type=script&lang=js"
export * from "./BannerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12198b01",
  null
  
)

export default component.exports